import { DsFormInstanceTableColumn } from './ds-form-instance-table-column';

export class DsFormInstanceTableRow {
  /**
   * Indew row
   */
  index: number;

  /**
   * List of columns
   */
  columns: DsFormInstanceTableColumn[];

  /**
   * DsFormInstanceTableRow constructor.
   *
   * @param index number Index of column
   */
  constructor(index: number) {
    this.index = index;
    this.columns = [];
  }
}
